import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getCurrentDate, getPastDate } from "../utils/formatTime";

// create slice
const name = "inmate";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const inmateAction = { ...slice.actions, ...extraActions };
export const inmateReducer = slice.reducer;

function createInitialState() {
  return {
    loading: false,
    error: null,
    noticeId: null,
    podList: [],
    inmateList: [],
    inmateFullList: [],
    securityResponse: null,
    connectionDataList: [],
    connectionDataFullList: [],
    loginLogHistory: [],
    loginLogFullHistory: [],
    inmate: {},
    PUMessageDataList: [],
    PUMessageDataIDSList: [],
    PUMessageDataFullList: [],
    FacilityQuarantineBlockRes: {},
    photoList: [],
    photoTotalCount: 0,
    phtotgridList: [],
    photoFullList: [],
    freeCreditList: [],
    freeCreditFullList: [],
    debitList: [],
    debitFullList: [],
    connectionRequestList: [],
    connectionRequestFullList: [],
    InmateDNDResponse: null,
    connectionReqCount: [],
    messageConversationdata: [],
    messaageConversationHeader: [],
    formTypedropdownList: [],
    FormHeader: [],
    AdminRemedyFormHeader: [],
    RequestAdminRemedy: null,
    visitorsFormrecords: [],
    ARFFormRecords: [],
    RFFFormRecords: [],
    RequestFormType: [],
    InitiateMessageRecords: [],
    postalMailRecords: [],
    securityQuestion: [],
    inmateRequestAccessFormData: [],
    inmateAccessMenuSetting: [],
    infoTabUpdateRes: null,
    relationShipupdateRes: null,
    inmateInfoTabData: [],
    facilityInfodata: [], // this value is used to show the setting => Access Fields
    podInfodata: [], // this value is used to show the setting => Access Fields
    initiateMessage: {
      FacilityID: 0,
      InmatesId: 0,
      RequestFormTypeID: 0,
      ManagementUserID: 0,
      DobStartDate: "",
      DobEndDate: "",
    },
    request: {
      FacilityID: 0,
      InmatesId: 0,
      InmateResidentID: "",
      PodID: 0,
      Type: 1,
      RequestFormTypeID: 0,
      NoticesID: 1,
      UserFirstName: "",
      UserLastName: "",
      ActiveStatus: 3,
      NoticesFromDate: "",
      NoticesToDate: "",
      DobStartDate: "",
      DobEndDate: "",
      ManagementUserID: 0,
      SortField: "",
    },
    intialMessageSearch: {
      FacilityID: 0,
      InmateID: 0,
      InmateResidentID: "",
      ManagementUserID: 0,
      UserID: 0,
      UserFirstNameId: 0,
      UserLastNameId: 0,
      UserFirstName: "",
      UserLastName: "",
      InmateFirstName: "",
      InmateLastName: "",
      MessageDirection: 0,
      MessageSendStartDate: getPastDate(6),
      MessageSendEndDate: getCurrentDate(),
      MessageFlag: 3,
      PageNo: 1,
      RowCountPerPage: 10,
      SortField: "MessageID desc",
    },
    intialPhotosSearch: {
      FacilityID: 0,
      InmateID: 0,
      InmateResidentID: "",
      ManagementUserID: 0,
      UserID: 0,
      UserFirstNameId: 0,
      UserLastNameId: 0,
      UserFirstName: "",
      UserLastName: "",
      PhotoAccess: 0,
      InmateFirstName: "",
      InmateLastName: "",
      Subject: "",
      NoticesFromDate: getPastDate(6),
      NoticesToDate: getCurrentDate(),
      ActiveStatus: 4,
      ReceiverRead: 4,
      PageNo: 1,
      RowCountPerPage: 10,
      SortField: "",
    },
    adminRemedyForm: [],
    securityQUpdateRes: null,
    securityresetRes: null,

    //Merge
    mergeInmate: [],
    newmergeInmate: [],
    mergeRes: null,

    //Excel Export
    requestFormData: [],

    //InmateCurrentTab
    inmateCurrentTab: "inmate-info-tab",

    //Transaction
    transactionDeatils: [],

    //Inmate List
    inmateSearchData: {
      InmateResidentID: "",
      UserFirstName: "",
      UserLastName: "",
      FacilityID: 0,
      PodID: 0,
      InmatesGender: 0,
      DobStartDate: "",
      DobEndDate: "",
      KiosksAccess: 2,
      ActiveStatus: 1,
      PageNo: 1,
      RowCountPerPage: 10,
      SortField: "", //asc desc
    },
  };
}

function createReducers() {
  return {
    setInmate,
    clearInmate,
    clearInmateFullList,
    clearSecurityResponse,
    clearConnectionFullList,
    clearLoginlogFullHistory,
    clearPUdataList,
    clearPhotoFullList,
    clearfreeCreditFullList,
    clearInmateDNDResponse,
    clearconnectionRequestFullList,
    clearMessageConversation,
    clearVisitorData,
    clearInitiateMessageRecords,
    clearPhotoList,
    clearPhotogridList,
    clearPostalMail,
    clearRelationShipupdateRes,
    setNoticeId,
    setRequestAdminRemedy,
    setInitiateMessgae,
    setinitialMessageSearch,
    setRequest,
    clearQSecurityResponse,
    clearInmateUpdateRes,
    setInmateCurrentTab,
    clearNoticeId,
    setInmateSearchData,
    resetInmateSearchData,
    setPhotoTotalCount,
    clearMergeResponse,
    clearInmateInfo,
    clearTransactionDeatils,
    clearsecurityresetRes,
    clearInitiateMessageSearch,
    setInitialPhotosSearch,
    clearInitialPhotosSearch
  };

  function clearsecurityresetRes(state) {
    state.securityresetRes = null;
  }
  function clearTransactionDeatils(state) {
    state.transactionDeatils = [];
  }

  function clearInmateInfo(state) {
    state.inmateInfoTabData = [];
  }

  function clearMergeResponse(state) {
    state.mergeRes = null;
  }

  function setPhotoTotalCount(state, action) {
    state.photoTotalCount = action && action.payload;
  }

  function setInmateSearchData(state, action) {
    state.inmateSearchData = action && action.payload;
  }

  function resetInmateSearchData(state, action) {
    state.inmateSearchData = {
      InmateResidentID: "",
      UserFirstName: "",
      UserLastName: "",
      FacilityID: 0,
      PodID: 0,
      InmatesGender: 0,
      DobStartDate: "",
      DobEndDate: "",
      KiosksAccess: 2,
      ActiveStatus: 1,
      PageNo: 1,
      RowCountPerPage: 10,
      SortField: "",
    };
  }

  function clearNoticeId(state) {
    state.noticeId = [];
  }
  function setRequestAdminRemedy(state, action) {
    state.RequestAdminRemedy = action && action.payload;
  }

  function setInmateCurrentTab(state, action) {
    state.inmateCurrentTab = action && action.payload;
  }

  function clearInmateUpdateRes(state) {
    state.infoTabUpdateRes = null;
  }

  function clearQSecurityResponse(state) {
    state.securityQUpdateRes = 0;
  }

  function setRequest(state, action) {
    state.request = action && action.payload;
  }

  function setInitiateMessgae(state, action) {
    state.initiateMessage = action && action.payload;
  }

  function setinitialMessageSearch(state, action) {
    state.intialMessageSearch = action && action.payload;
  }

  function clearInitiateMessageSearch(state) {
    state.intialMessageSearch = {
      FacilityID: 0,
      InmateID: 0,
      InmateResidentID: "",
      ManagementUserID: 0,
      UserID: 0,
      UserFirstNameId: 0,
      UserLastNameId: 0,
      UserFirstName: "",
      UserLastName: "",
      InmateFirstName: "",
      InmateLastName: "",
      MessageDirection: 0,
      MessageSendStartDate: getPastDate(6),
      MessageSendEndDate: getCurrentDate(),
      MessageFlag: 3,
      PageNo: 1,
      RowCountPerPage: 10,
      SortField: "MessageID desc",
    };
  }

  function setInitialPhotosSearch(state, action) {
    state.intialPhotosSearch = action && action.payload;
  }

  function clearInitialPhotosSearch(state) {
    state.intialPhotosSearch = {
      FacilityID: 0,
      InmateID: 0,
      InmateResidentID: "",
      ManagementUserID: 0,
      UserID: 0,
      UserFirstNameId: 0,
      UserLastNameId: 0,
      UserFirstName: "",
      UserLastName: "",
      PhotoAccess: 0,
      InmateFirstName: "",
      InmateLastName: "",
      Subject: "",
      NoticesFromDate: getPastDate(6),
      NoticesToDate: getCurrentDate(),
      ActiveStatus: 4,
      ReceiverRead: 4,
      PageNo: 1,
      RowCountPerPage: 10,
      SortField: "",
    };
  }

  function setNoticeId(state, action) {
    state.noticeId = action && action.payload;
  }

  function setInmate(state, action) {
    state.inmate = action && action.payload;
  }

  function clearInmate(state) {
    state.inmate = {};
  }

  function clearInmateFullList(state) {
    state.inmateFullList = [];
  }

  function clearSecurityResponse(state) {
    state.securityResponse = null;
  }

  function clearConnectionFullList(state) {
    state.connectionDataFullList = null;
  }

  function clearLoginlogFullHistory(state) {
    state.loginLogFullHistory = [];
  }

  function clearPUdataList(state) {
    state.PUMessageDataFullList = [];
  }

  function clearPhotoFullList(state) {
    state.photoFullList = [];
  }

  function clearPhotogridList(state) {
    state.phtotgridList = [];
  }

  function clearfreeCreditFullList(state) {
    state.freeCreditFullList = [];
  }

  function clearInmateDNDResponse(state) {
    state.InmateDNDResponse = null;
  }

  function clearconnectionRequestFullList(state) {
    state.connectionRequestFullList = [];
  }

  function clearMessageConversation(state) {
    state.messageConversationdata = [];
  }

  function clearVisitorData(state) {
    state.VFRFormRecords = [];
    state.visitorsFormrecords = [];
    state.ARFFormRecords = [];
    state.RFFFormRecords = [];
    state.adminRemedyForm = [];
  }

  function clearInitiateMessageRecords(state) {
    state.InitiateMessageRecords = [];
  }

  function clearPhotoList(state) {
    state.photoList = [];
  }

  function clearPostalMail(state) {
    state.postalMailRecords = [];
  }

  function clearRelationShipupdateRes(state) {
    state.relationShipupdateRes = null;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    LoadPodDropDown: LoadPodDropDown(),
    LoadInmatesSearch: LoadInmatesSearch(),
    InmateSecurityQuestion: InmateSecurityQuestion(),
    LoadInmatePublicConnection: LoadInmatePublicConnection(),
    LoadInmateLoginLogHistory: LoadInmateLoginLogHistory(),
    LoadPUMessageSearch: LoadPUMessageSearch(),
    LoadPUMessageIDList: LoadPUMessageIDList(),
    LoadFacilityQuarantineBlock: LoadFacilityQuarantineBlock(),
    LoadPhotoSearchResult: LoadPhotoSearchResult(),
    LoadPhotoSearch: LoadPhotoSearch(),
    GetInmateFreeCreditDetails: GetInmateFreeCreditDetails(),
    LoadCactasTransactionHistory: LoadCactasTransactionHistory(),
    GetInmateInvitePublicUserSearch: GetInmateInvitePublicUserSearch(),
    InmateDnd: InmateDnd(),
    GetLoadInmateInvitePublicCount: GetLoadInmateInvitePublicCount(),
    MessageConversationInmate: MessageConversationInmate(),
    MessageConversationInmateHeader: MessageConversationInmateHeader(),
    GetManagementRequestFormDropDown: GetManagementRequestFormDropDown(),
    RequestFormTypeReport: RequestFormTypeReport(),
    InmateRequestVisitorInfo: InmateRequestVisitorInfo(),
    LoadRequestFormTypeReportExportList: LoadRequestFormTypeReportExportList(),
    LoadLRRFormInmateExport: LoadLRRFormInmateExport(),
    LoadRequestMGUserThreadInmateExport: LoadRequestMGUserThreadInmateExport(),
    GetFacilityRequestFormType: GetFacilityRequestFormType(),
    LoadPostalMailSearch: LoadPostalMailSearch(),
    LoadRequestThreadInmateExport: LoadRequestThreadInmateExport(),
    //Inmate Info => Settings
    InmatesInfoTab: InmatesInfoTab(),
    GetLoadInmateSecurityQuestionSet: GetLoadInmateSecurityQuestionSet(),
    LoadInmateRequestAccessSettings: LoadInmateRequestAccessSettings(),
    LoadInmateAccessMenuSettings: LoadInmateAccessMenuSettings(),
    InmateInfoUpdateDetails: InmateInfoUpdateDetails(),
    GetFacilityInfo: GetFacilityInfo(),
    GetPODInfo: GetPODInfo(),
    //security Func
    InmateSecurityQuestionInsertUpdate: InmateSecurityQuestionInsertUpdate(),
    GetInmateResetSecurityQuestion: GetInmateResetSecurityQuestion(),

    //PUIRelationShipUpdateHistory
    PUIRelationShipUpdateHistory: PUIRelationShipUpdateHistory(),

    LoadInmateRequestAdminRemedy: LoadInmateRequestAdminRemedy(),

    //GetMergeToInmateDisplayDropdown
    GetMergeToInmateDisplayDropdown: GetMergeToInmateDisplayDropdown(),
    MergeInmateDetails: MergeInmateDetails(),
    LoadMergeToInmateDisplay: LoadMergeToInmateDisplay(),

    //Transaction Tab
    LoadCreditDebitTransactionDetails: LoadCreditDebitTransactionDetails(),
  };

  function LoadCreditDebitTransactionDetails() {
    return createAsyncThunk(
      `${name}/LoadCreditDebitTransactionDetails`,
      async (param) =>
        await fetchWrapper.post(
          // `${baseUrl}/ManagementUser/PublicUser/LoadCreditDebitTransactionDetails`,
          `${baseUrl}/ManagementUser/PublicUser/LoadCreditDebitTransactionDetails`,
          param
        )
    );
  }

  function GetInmateResetSecurityQuestion() {
    return createAsyncThunk(
      `${name}/GetInmateResetSecurityQuestion`,
      async ({ inmateId, FacilityID }) =>
        await fetchWrapper.get(
          `${baseUrl}/ManagementUser/Inmate/GetInmateResetSecurityQuestion?inmateId=${inmateId}&facilityID=${FacilityID}`
        )
    );
  }

  function LoadInmateRequestAdminRemedy() {
    return createAsyncThunk(
      `${name}/LoadInmateRequestAdminRemedy`,
      async (Id) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/InmateRequestAdminRemedy?requestAdminRemedyID=${Id}`
        )
    );
  }

  function LoadPodDropDown() {
    return createAsyncThunk(
      `${name}/LoadPodDropDown`,
      async ({ FacilityID, SharedPod, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/Common/LoadPodDropDown?FacilityID=${FacilityID}&SharedPod=${SharedPod}&activeStatus=${Status}`
        )
    );
  }

  function LoadInmatesSearch() {
    return createAsyncThunk(
      `${name}/LoadInmatesSearch`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/LoadInmatesSearch`,
          param
        )
    );
  }

  function InmateSecurityQuestion() {
    return createAsyncThunk(
      `${name}/InmateSecurityQuestion`,
      async ({ inmateId, facilityID, action }) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/InmateSecurityQuestion?inmateId=${inmateId}&facilityID=${facilityID}&action=${action}`
        )
    );
  }

  function LoadInmatePublicConnection() {
    return createAsyncThunk(
      `${name}/LoadInmatePublicConnection`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/LoadInmatePublicConnection`,
          param
        )
    );
  }

  function LoadInmateLoginLogHistory() {
    return createAsyncThunk(
      `${name}/LoadInmateLoginLogHistory`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/LoadInmateLoginLogHistory`,
          param
        )
    );
  }

  function LoadPUMessageSearch() {
    return createAsyncThunk(
      `${name}/LoadPUMessageSearch`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/PublicUsers/LoadPUMessageSearch`,
          param
        )
    );
  }

  function LoadPUMessageIDList() {
    return createAsyncThunk(
      `${name}/LoadPUMessageIDList`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/PublicUsers/LoadPUMessageIDList`,
          param
        )
    );
  }

  function LoadFacilityQuarantineBlock() {
    return createAsyncThunk(
      `${name}/LoadFacilityQuarantineBlock`,
      async ({ facilityId }) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/PublicUsers/LoadFacilityQuarantineBlock?facility=${facilityId}`
        )
    );
  }

  function LoadPhotoSearch() {
    return createAsyncThunk(
      `${name}/LoadS3PhotosDetailsListDownload`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Photos/LoadS3PhotosDetailsListDownload`,
          {
            ...param, PhotoSendStartDate: param?.NoticesFromDate, PhotoSendEndDate: param?.NoticesToDate,
            PhotoActionStatus: param?.ActiveStatus, publicFirstName: param?.UserFirstName, publicLastName: param?.UserLastName,
            PhotoSubject: param?.Subject
          }
        )
    );
  }

  function LoadPhotoSearchResult() {
    return createAsyncThunk(
      `${name}/LoadPhotosList`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Photos/LoadPhotosList`,
          {
            ...param, PhotoSendStartDate: param?.NoticesFromDate, PhotoSendEndDate: param?.NoticesToDate,
            PhotoActionStatus: param?.ActiveStatus, publicFirstName: param?.UserFirstName, publicLastName: param?.UserLastName,
            PhotoSubject: param?.Subject, SortBy: param?.SortField
          }
        )
    );
  }

  function GetInmateFreeCreditDetails() {
    return createAsyncThunk(
      `${name}/GetInmateFreeCreditDetails`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/GetInmateFreeCreditDetails`,
          param
        )
    );
  }

  function LoadCactasTransactionHistory() {
    return createAsyncThunk(
      `${name}/LoadCactasTransactionHistory`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/LoadCactasTransactionHistory`,
          param
        )
    );
  }

  function GetInmateInvitePublicUserSearch() {
    return createAsyncThunk(
      `${name}/GetInmateInvitePublicUserSearch`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/GetInmateInvitePublicUserSearch`,
          param
        )
    );
  }

  function InmateDnd() {
    return createAsyncThunk(
      `${name}/InmateDnd`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/InmateDnd`,
          param
        )
    );
  }

  function GetLoadInmateInvitePublicCount() {
    return createAsyncThunk(
      `${name}/GetLoadInmateInvitePublicCount`,
      async ({ InmatesID, facilityID }) =>
        await fetchWrapper.get(
          `${baseUrl}/Kiosk/MyInvites/GetLoadInmateInvitePublicCount?inmateId=${InmatesID}&facilityID=${facilityID}`
        )
    );
  }

  //Reports
  function MessageConversationInmate() {
    return createAsyncThunk(
      `${name}/MessageConversationInmate`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/MessageConversationInmate`,
          param
        )
    );
  }

  function MessageConversationInmateHeader() {
    return createAsyncThunk(
      `${name}/MessageConversationInmateHeader`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/MessageConversationInmateHeader`,
          param
        )
    );
  }

  function GetManagementRequestFormDropDown() {
    return createAsyncThunk(
      `${name}/GetManagementRequestFormDropDown`,
      async ({ mangementUserID, facilityId }) =>
        await fetchWrapper.get(
          `${baseUrl}/ManagementUser/Reporting/GetManagementRequestForumFormDropDown/?mangementUserID=${mangementUserID}&facilityID=${facilityId}`
        )
    );
  }

  function RequestFormTypeReport() {
    return createAsyncThunk(
      `${name}/RequestFormTypeReport`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/RequestFormTypeReport`,
          param
        )
    );
  }

  function InmateRequestVisitorInfo() {
    return createAsyncThunk(
      `${name}/InmateRequestVisitorInfo`,
      async (noticesId) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/InmateRequestVisitorInfo?noticesId=${noticesId}`
        )
    );
  }

  function LoadRequestFormTypeReportExportList() {
    return createAsyncThunk(
      `${name}/LoadRequestFormTypeReportExportList`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/LoadRequestFormTypeReportExportList`,
          param
        )
    );
  }

  function LoadLRRFormInmateExport() {
    return createAsyncThunk(
      `${name}/LoadLRRFormInmateExport`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/LoadLRRFormInmateExport`,
          param
        )
    );
  }

  function LoadRequestThreadInmateExport() {
    return createAsyncThunk(
      `${name}/LoadRequestThreadInmateExport`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/RequestThreadInmateExport`,
          param
        )
    );
  }
  //Initiate Message To Inmate LoadRequestMGUserThreadInmateExport
  function LoadRequestMGUserThreadInmateExport() {
    return createAsyncThunk(
      `${name}/LoadRequestMGUserThreadInmateExport`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/LoadRequestMGUserThreadInmateExport`,
          param
        )
    );
  }

  function GetFacilityRequestFormType() {
    return createAsyncThunk(
      `${name}/GetFacilityRequestFormType`,
      async ({ facilityId }) =>
        await fetchWrapper.get(
          `${baseUrl}/Master/GetFacilityRequestFormType?facilityId=${facilityId}&ActiveStatus=2`
        )
    );
  }

  //PostaMAil LoadData
  function LoadPostalMailSearch() {
    return createAsyncThunk(
      `${name}/LoadPostalMailSearch`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/LoadPostalMailSearch`,
          param
        )
    );
  }

  //Inmate Info => Setting
  function GetLoadInmateSecurityQuestionSet() {
    return createAsyncThunk(
      `${name}/GetLoadInmateSecurityQuestionSet`,
      async ({ InmatesID, FacilityID }) =>
        await fetchWrapper.get(
          `${baseUrl}/Kiosk/KioskLogin/GetLoadInmateSecurityQuestionSet?inmateId=${InmatesID}&facilityID=${FacilityID}`
        )
    );
  }

  function LoadInmateRequestAccessSettings() {
    return createAsyncThunk(
      `${name}/LoadInmateRequestAccessSettings`,
      async ({ InmatesID, FacilityID }) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/LoadInmateRequestAccessSettings?facilityID=${FacilityID}&inmatesId=${InmatesID}`
        )
    );
  }

  function LoadInmateAccessMenuSettings() {
    return createAsyncThunk(
      `${name}/LoadInmateAccessMenuSettings`,
      async ({ InmatesID, FacilityID }) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/LoadInmateAccessMenuSettings?inmatesId=${InmatesID}&facilityID=${FacilityID}`
        )
    );
  }

  function InmateInfoUpdateDetails() {
    return createAsyncThunk(
      `${name}/InmateInfoUpdateDetails`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/InmateInfoUpdateDetails`,
          param
        )
    );
  }

  function PUIRelationShipUpdateHistory() {
    return createAsyncThunk(
      `${name}/PUIRelationShipUpdateHistory`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/PublicUsers/PUIRelationShipUpdateHistory`,
          param
        )
    );
  }

  function InmatesInfoTab() {
    return createAsyncThunk(
      `${name}/InmatesInfoTab`,
      async (inmateId) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/InmatesInfo?inmatesId=${inmateId}`
        )
    );
  }

  function GetFacilityInfo() {
    return createAsyncThunk(
      `${name}/GetFacilityInfo`,
      async (facilityID) =>
        await fetchWrapper.get(
          `${baseUrl}/ManagementUser/Facility/GetFacilityDetailsForManagementUser?facilityID=${facilityID}`
        )
    );
  }

  function GetPODInfo() {
    return createAsyncThunk(
      `${name}/GetPODInfo`,
      async (PodID) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Pod/GetPODInfo?PodID=${PodID}`
        )
    );
  }

  function InmateSecurityQuestionInsertUpdate() {
    return createAsyncThunk(
      `${name}/InmateSecurityQuestionInsertUpdate`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/InmateSecurityQuestionInsertUpdate`,
          param
        )
    );
  }

  function GetMergeToInmateDisplayDropdown() {
    return createAsyncThunk(
      `${name}/GetMergeToInmateDisplayDropdown`,
      async ({ facilityID, mergeFromInmateid }) =>
        await fetchWrapper.get(
          `${baseUrl}/ManagementUser/Inmate/GetMergeToInmateDisplayDropdown?facilityID=${facilityID}&mergeFromInmateid=${mergeFromInmateid}&mergeToInmateid=${0}`
        )
    );
  }

  function MergeInmateDetails() {
    return createAsyncThunk(
      `${name}/MergeInmateDetails`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/MergeInmateDetails`,
          param
        )
    );
  }

  function LoadMergeToInmateDisplay() {
    return createAsyncThunk(
      `${name}/LoadMergeToInmateDisplay`,
      async ({ facilityID, mergeFromInmateid }) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Inmate/LoadMergeToInmateDisplay?facilityID=${facilityID}&mergeFromInmateid=${mergeFromInmateid}&mergeToInmateid=${0}`
        )
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.LoadPodDropDown.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadPodDropDown.fulfilled, (state, action) => {
      state.loading = false;
      state.podList = action && action.payload;
    })
    .addCase(extraActions.LoadPodDropDown.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    .addCase(extraActions.LoadInmatesSearch.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadInmatesSearch.fulfilled, (state, action) => {
      state.loading = false;
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.inmateFullList = action.payload;
      } else {
        state.inmateList = action.payload;
      }
      state.error = null;
    })
    .addCase(extraActions.LoadInmatesSearch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //InmateSecurityQuestion
    .addCase(extraActions.InmateSecurityQuestion.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.InmateSecurityQuestion.fulfilled, (state, action) => {
      state.loading = false;
      state.securityResponse = action && action.payload;
    })
    .addCase(extraActions.InmateSecurityQuestion.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //LoadInmatePublicConnection
    .addCase(extraActions.LoadInmatePublicConnection.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadInmatePublicConnection.fulfilled,
      (state, action) => {
        state.loading = false;

        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.connectionDataFullList = action.payload;
        } else {
          state.connectionDataList = action.payload;
        }
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadInmatePublicConnection.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //
    .addCase(extraActions.LoadInmateLoginLogHistory.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadInmateLoginLogHistory.fulfilled,
      (state, action) => {
        state.loading = false;

        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.loginLogFullHistory = action.payload;
        } else {
          state.loginLogHistory = action.payload;
        }
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadInmateLoginLogHistory.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //LoadPUMessageSearch
    .addCase(extraActions.LoadPUMessageSearch.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadPUMessageSearch.fulfilled, (state, action) => {
      state.loading = false;

      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.PUMessageDataFullList = action.payload;
      } else {
        state.PUMessageDataList = action.payload;
      }
      state.error = null;
    })
    .addCase(extraActions.LoadPUMessageSearch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    .addCase(extraActions.LoadPUMessageIDList.pending, (state) => {
      state.loading = true;
      state.PUMessageDataIDSList = {};
      state.error = null;
    })
    .addCase(extraActions.LoadPUMessageIDList.fulfilled, (state, action) => {
      state.loading = false;
      state.PUMessageDataIDSList = action.payload;
      state.error = null;
    })
    .addCase(extraActions.LoadPUMessageIDList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //Load the Flag Dropdown List LoadFacilityQuarantineBlock
    .addCase(extraActions.LoadFacilityQuarantineBlock.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadFacilityQuarantineBlock.fulfilled,
      (state, action) => {
        state.loading = false;
        state.FacilityQuarantineBlockRes = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadFacilityQuarantineBlock.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //Load the Photo Tab Grid
    .addCase(extraActions.LoadPhotoSearch.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadPhotoSearch.fulfilled, (state, action) => {
      state.loading = false;

      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.photoFullList = action.payload;
      } else {
        state.photoList = action.payload;
      }
      state.error = null;
    })
    .addCase(extraActions.LoadPhotoSearch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //LoadPhotoSearchResult
    .addCase(extraActions.LoadPhotoSearchResult.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadPhotoSearchResult.fulfilled, (state, action) => {
      state.loading = false;

      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.photoFullList = action.payload;
      } else {
        state.phtotgridList = action.payload;
      }
      state.error = null;
    })
    .addCase(extraActions.LoadPhotoSearchResult.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //Load the Free Credit Grid GetInmateFreeCreditDetails
    .addCase(extraActions.GetInmateFreeCreditDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetInmateFreeCreditDetails.fulfilled,
      (state, action) => {
        state.loading = false;

        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.freeCreditFullList = action.payload;
        } else {
          state.freeCreditList = action.payload;
        }
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetInmateFreeCreditDetails.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //Load the Debit Grid LoadCactasTransactionHistory
    .addCase(extraActions.LoadCactasTransactionHistory.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadCactasTransactionHistory.fulfilled,
      (state, action) => {
        state.loading = false;

        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.debitFullList = action.payload;
        } else {
          state.debitList = action.payload;
        }
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadCactasTransactionHistory.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //Load the Data for Connection Tab Grid GetInmateInvitePublicUserSearch
    .addCase(extraActions.GetInmateInvitePublicUserSearch.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetInmateInvitePublicUserSearch.fulfilled,
      (state, action) => {
        state.loading = false;

        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.connectionRequestFullList = action.payload;
        } else {
          state.connectionRequestList = action.payload;
        }
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetInmateInvitePublicUserSearch.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //Bind Connection Requests Values GetLoadInmateInvitePublicCount
    .addCase(extraActions.GetLoadInmateInvitePublicCount.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetLoadInmateInvitePublicCount.fulfilled,
      (state, action) => {
        state.loading = false;
        state.connectionReqCount = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetLoadInmateInvitePublicCount.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //InmateDnd
    .addCase(extraActions.InmateDnd.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.InmateDnd.fulfilled, (state, action) => {
      state.loading = false;
      state.InmateDNDResponse = action.payload;
      state.error = null;
    })
    .addCase(extraActions.InmateDnd.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //Load the data for download MessageConversationInmate
    .addCase(extraActions.MessageConversationInmate.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.MessageConversationInmate.fulfilled,
      (state, action) => {
        state.loading = false;
        state.messageConversationdata = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.MessageConversationInmate.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    // MessageConversationInmateHeader
    .addCase(extraActions.MessageConversationInmateHeader.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.MessageConversationInmateHeader.fulfilled,
      (state, action) => {
        state.loading = false;
        state.messaageConversationHeader = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.MessageConversationInmateHeader.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    // GetManagementRequestFormDropDown
    .addCase(extraActions.GetManagementRequestFormDropDown.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetManagementRequestFormDropDown.fulfilled,
      (state, action) => {
        state.loading = false;
        state.formTypedropdownList = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetManagementRequestFormDropDown.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    // RequestFormTypeReport
    .addCase(extraActions.RequestFormTypeReport.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.RequestFormTypeReport.fulfilled, (state, action) => {
      state.loading = false;
      let params = action.meta.arg;
      if (params?.NoticesID === 1) {
        state.FormHeader = action.payload;
      } else if (params?.NoticesID === 2) {
        state.AdminRemedyFormHeader = action.payload;
      }

      state.error = null;
    })
    .addCase(extraActions.RequestFormTypeReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //InmateRequestVisitorInfo
    .addCase(extraActions.InmateRequestVisitorInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.InmateRequestVisitorInfo.fulfilled,
      (state, action) => {
        state.loading = false;
        state.visitorsFormrecords = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.InmateRequestVisitorInfo.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //LoadRequestFormTypeReportExportList ARFFormRecords
    .addCase(
      extraActions.LoadRequestFormTypeReportExportList.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadRequestFormTypeReportExportList.fulfilled,
      (state, action) => {
        state.loading = false;
        let params = action.meta.arg;
        if (params?.noticesID === 1) {
          state.VFRFormRecords = action.payload;
        } else if (params?.noticesID === 2) {
          state.ARFFormRecords = action.payload;
        }
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadRequestFormTypeReportExportList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //LoadLRRFormInmateExport RFFFormRecords
    .addCase(extraActions.LoadLRRFormInmateExport.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadLRRFormInmateExport.fulfilled,
      (state, action) => {
        state.loading = false;
        state.RFFFormRecords = action.payload;
        state.error = null;
      }
    )
    .addCase(extraActions.LoadLRRFormInmateExport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //Load LoadRequestThreadInmateExport
    .addCase(extraActions.LoadRequestThreadInmateExport.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadRequestThreadInmateExport.fulfilled,
      (state, action) => {
        state.loading = false;
        state.RFFFormRecords = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadRequestThreadInmateExport.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //LoadRequestMGUserThreadInmateExport
    .addCase(
      extraActions.LoadRequestMGUserThreadInmateExport.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadRequestMGUserThreadInmateExport.fulfilled,
      (state, action) => {
        state.loading = false;
        state.InitiateMessageRecords = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadRequestMGUserThreadInmateExport.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //Get the Type Dropdown Values For InitateInmateMessageTab
    .addCase(extraActions.GetFacilityRequestFormType.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetFacilityRequestFormType.fulfilled,
      (state, action) => {
        state.loading = false;
        state.RequestFormType = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetFacilityRequestFormType.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //Load the Postal MAil Data
    .addCase(extraActions.LoadPostalMailSearch.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadPostalMailSearch.fulfilled, (state, action) => {
      state.loading = false;
      state.postalMailRecords = action.payload;
      state.error = null;
    })
    .addCase(extraActions.LoadPostalMailSearch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //Setting Inmate Info

    //To get security Questions
    .addCase(extraActions.GetLoadInmateSecurityQuestionSet.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetLoadInmateSecurityQuestionSet.fulfilled,
      (state, action) => {
        state.loading = false;
        state.securityQuestion = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetLoadInmateSecurityQuestionSet.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //LoadInmateRequestAccessSettings inmateRequestAccessFormData
    .addCase(extraActions.LoadInmateRequestAccessSettings.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadInmateRequestAccessSettings.fulfilled,
      (state, action) => {
        state.loading = false;
        state.inmateRequestAccessFormData = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadInmateRequestAccessSettings.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //LoadInmateAccessMenuSettings  inmateAccessMenuSetting
    .addCase(extraActions.LoadInmateAccessMenuSettings.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadInmateAccessMenuSettings.fulfilled,
      (state, action) => {
        state.loading = false;
        state.inmateAccessMenuSetting = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadInmateAccessMenuSettings.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //InmateInfoUpdateDetails infoTabUpdateRes
    .addCase(extraActions.InmateInfoUpdateDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.InmateInfoUpdateDetails.fulfilled,
      (state, action) => {
        state.loading = false;
        state.infoTabUpdateRes = action.payload;
        state.error = null;
      }
    )
    .addCase(extraActions.InmateInfoUpdateDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    // PUIRelationShipUpdateHistory
    .addCase(extraActions.PUIRelationShipUpdateHistory.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.PUIRelationShipUpdateHistory.fulfilled,
      (state, action) => {
        state.loading = false;
        state.relationShipupdateRes = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.PUIRelationShipUpdateHistory.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //inmateInfoData InmatesInfo
    .addCase(extraActions.InmatesInfoTab.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.InmatesInfoTab.fulfilled, (state, action) => {
      state.loading = false;
      state.inmateInfoTabData = action.payload;
      state.error = null;
    })
    .addCase(extraActions.InmatesInfoTab.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //GetFacilityInfo (this data is used to show the Setting Tab Field)
    .addCase(extraActions.GetFacilityInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetFacilityInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.facilityInfodata = action.payload;
      state.error = null;
    })
    .addCase(extraActions.GetFacilityInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    // GetPODInfo (this data is used to show the Setting Tab Field)
    .addCase(extraActions.GetPODInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetPODInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.podInfodata = action.payload;
      state.error = null;
    })
    .addCase(extraActions.GetPODInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //LoadInmateRequestAdminRemedy
    .addCase(extraActions.LoadInmateRequestAdminRemedy.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadInmateRequestAdminRemedy.fulfilled,
      (state, action) => {
        state.loading = false;
        // Ensure `state.adminRemedyForm` is always an array
        if (!Array.isArray(state.adminRemedyForm)) {
          state.adminRemedyForm = [];
        }

        // Append new data instead of replacing it
        state.adminRemedyForm = [...state.adminRemedyForm, ...action.payload];
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadInmateRequestAdminRemedy.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //InmateSecurityQuestionInsertUpdate
    .addCase(
      extraActions.InmateSecurityQuestionInsertUpdate.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.InmateSecurityQuestionInsertUpdate.fulfilled,
      (state, action) => {
        state.loading = false;
        state.securityQUpdateRes = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.InmateSecurityQuestionInsertUpdate.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //GetInmateResetSecurityQuestion
    .addCase(extraActions.GetInmateResetSecurityQuestion.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetInmateResetSecurityQuestion.fulfilled,
      (state, action) => {
        state.loading = false;
        state.securityresetRes = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetInmateResetSecurityQuestion.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //GetMergeToInmateDisplayDropdown
    .addCase(extraActions.GetMergeToInmateDisplayDropdown.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetMergeToInmateDisplayDropdown.fulfilled,
      (state, action) => {
        state.loading = false;
        state.mergeInmate = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetMergeToInmateDisplayDropdown.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //MergeInmateDetails
    .addCase(extraActions.MergeInmateDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.MergeInmateDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.mergeRes = action.payload;
      state.error = null;
    })
    .addCase(extraActions.MergeInmateDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //LoadMergeToInmateDisplay
    .addCase(extraActions.LoadMergeToInmateDisplay.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadMergeToInmateDisplay.fulfilled,
      (state, action) => {
        state.loading = false;
        state.newmergeInmate = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadMergeToInmateDisplay.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //LoadCreditDebitTransactionDetails
    .addCase(
      extraActions.LoadCreditDebitTransactionDetails.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadCreditDebitTransactionDetails.fulfilled,
      (state, action) => {
        state.loading = false;
        state.transactionDeatils = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadCreditDebitTransactionDetails.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    );
}
